import miaPic from "@/public/images/artists/mia.jpg";
import { Artist } from "@/types/types";

export const mia = {
  id: "112",
  name: "Mia",
  image: miaPic,
  description: `Mia has a dark and thick voice that displays advanced technical proficiency, executing complex vocal runs with precise pitch control. It possesses a distinct low register, and its timbre exudes a rich, deep resonance.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fmia-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Dance", "Soul", "Rock", "Belting", "Funk", "Deep"],
      secondary: ["Wide Range"],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Very high",
      },
      specific: {
        low: 52,
        high: 75,
      },
    },
  },
} as const satisfies Artist;
